import {
  intlAssetValueFormatting,
  intlFiatValueFormatting,
} from '@bts-web/utils-formatting';
import { getAppConfig } from '@bts-web/core-app-config';
import { CryptoTransferDetailsFooter } from '../CryptoTransferDetailsFooter/CryptoTransferDetailsFooter';
import type { TransactionDetailsTransactionKeysResult } from '../../transaction-details/utils';
import {
  TransactionDetailsTitle,
  TransactionDetailsWrapper,
} from '../../transaction-details';
import { CryptoTransfersTransactionsItemType } from '../../transaction-details/types';
import { GenericErrorMessage } from '../../layouts/GenericErrorMessage/GenericErrorMessage';

export interface CryptoTransferDetailsProps {
  title?: string | null;
  translations: TransactionDetailsTransactionKeysResult;
  locale: string;
  cryptoTransferTransaction: NonNullable<CryptoTransfersTransactionsItemType>;
  refetchCryptoTransfersTransactions?: () => void;
}

export const CryptoTransferDetails = ({
  translations,
  cryptoTransferTransaction,
  locale,
  refetchCryptoTransfersTransactions,
}: CryptoTransferDetailsProps) => {
  const { currency } = getAppConfig();

  const { __typename, fiatAmount, assetAmount, asset } =
    cryptoTransferTransaction;

  const isWithdrawalTransferType =
    __typename === 'WithdrawalCryptoTransfersTransaction';

  const subtitle = isWithdrawalTransferType
    ? `${translations.sent} ${intlFiatValueFormatting(fiatAmount?.value ?? 0, {
        locale,
        currency,
        fractionDigits: fiatAmount?.precision ?? 2,
      })}`
    : `${translations.received} ${intlAssetValueFormatting(assetAmount?.value as string, { locale })} ${asset?.symbol}`;

  if (cryptoTransferTransaction === null) {
    return <GenericErrorMessage />;
  }

  return (
    <>
      <TransactionDetailsTitle
        title={translations.details}
        subtitle={subtitle}
      />

      <TransactionDetailsWrapper
        transaction={cryptoTransferTransaction}
        translations={translations}
        locale={locale}
        currency={currency}
      />

      <CryptoTransferDetailsFooter
        cryptoTransferTransaction={cryptoTransferTransaction}
        translations={translations}
        refetchCryptoTransfersTransactions={refetchCryptoTransfersTransactions}
      />
    </>
  );
};
